import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import "./payment.css";

const Failed = () => {
  const navigate = useNavigate();
  const selectedPlan = React.useMemo(() => {
    const plan = localStorage.getItem("selectedPlan");
    return plan ? JSON.parse(plan as any) : {};
  }, []);

  React.useEffect(() => {
    if (selectedPlan && selectedPlan.total_amount) {
      // No need to setPayments, just check
    } else {
      navigate("/home");
    }
  }, [selectedPlan, navigate]);

  return (
    <Box className="centered-success-container">
      <Box className="paymentMessageContainer">
        <img
          src={'/assets/paymentFailed.svg'}
          alt="Payment Failed"
          className="PaymentImage"
        />
        <Typography variant="body2" className="paymentMessageText">
          Payment Failed
        </Typography>
        <Typography
          variant="body2"
          component="p"
          className="paymentMessageText"
        >
          Please try again. your payment failed and no charges were made
        </Typography>
        <Button
          variant="contained"
          sx={{ bgcolor: "#6A1B9A", width: "80px", mt: 2 }}
          className="modalButton"
          onClick={() => {
            navigate("/home");
            localStorage.removeItem("selectedPlan");
          }}
        >
          Try Again
        </Button>
      </Box>
    </Box>
  );
};

export default Failed;
